import axios from 'axios';

// Build-time: set VITE_API_URL from backend stack ApiUrl when deploying. Fallback for local dev only.
const BUILD_API_URL =
  import.meta.env.VITE_API_URL ||
  'http://localhost:3001';

// Test env: force test API when opened on the test CloudFront host (avoids prod API + wrong S3 bucket).
const TEST_FRONTEND_HOST = (import.meta.env.VITE_TEST_FRONTEND_HOST || '').trim();
const TEST_CLOUDFRONT_HOSTS = (import.meta.env.VITE_TEST_CLOUDFRONT_HOSTS || '')
  .split(',')
  .map((h) => h.trim())
  .filter(Boolean);
const TEST_API_URL = (import.meta.env.VITE_API_URL_TEST || import.meta.env.VITE_API_URL || '').trim();
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isTestFrontend =
  TEST_API_URL &&
  (TEST_CLOUDFRONT_HOSTS.includes(hostname) ||
    (TEST_FRONTEND_HOST && hostname === TEST_FRONTEND_HOST));
const API_URL = isTestFrontend ? TEST_API_URL : BUILD_API_URL;

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ensure token is sent on every request (avoids 401 on large bodies where defaults can be dropped)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Login/register can return 401 for wrong credentials — not a session expiry; do not wipe state or hard-redirect
      const isCredentialCheck =
        url.includes('/auth/login') || url.includes('/auth/register');
      if (isCredentialCheck) {
        return Promise.reject(error);
      }
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      delete api.defaults.headers.common.Authorization;
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

